import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/sales/$purchaseId")({
  component: lazyRouteComponent(() => import("./+Sale")),
  head: () => ({
    meta: seo({ title: "Sale" }),
  }),
});
